import { render, staticRenderFns } from "./warehouseSendMessage.vue?vue&type=template&id=13844c43"
import script from "./warehouseSendMessage.vue?vue&type=script&lang=js"
export * from "./warehouseSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports